import React, { useCallback } from 'react';
import Alert from 'utils/packages/Alert';
import { emojify } from 'node-emoji';
import Modal from 'utils/packages/Modal';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconRectangleListSolid } from 'design-system/icons';
import { IconWifi } from 'design-system/icons/IconWifi';
import useColors from 'hooks/useColors';
import IconTransaction from 'design-system/icons/IconTransaction';
import { Sign } from 'utils/types/navigation';
import { groupModalContainerStyle } from './groupModalContainerStyle';
export const AddTransactionModalContent = ({ groupId, navigation }) => {
    const colors = useColors();
    const onFromTransactionScreen = useCallback(() => {
        Modal.hide(() => navigation.navigateDeprecated('GroupSelectTransactions', {
            groupId,
            isMultipleSelect: true,
            onContinue: (selectedTxns) => {
                navigation.navigateDeprecated('GroupExpense', {
                    groupId,
                    transactions: selectedTxns,
                });
            },
        }));
    }, [groupId]);
    const onCustomTransaction = useCallback(() => {
        Modal.hide(() => navigation.navigateDeprecated('AddBalance', {
            custom: {
                title: 'What’s the amount for this\ntransaction?',
                // only the web version of AddBalance reads this
                webSubtitle: 'What’s the amount for this transaction?',
                button: 'Continue',
                swapText: {
                    [Sign.Positive]: 'Swap to spending',
                    [Sign.Negative]: 'Swap to income',
                },
                initialSign: Sign.Negative,
                icon: (<IconTransaction width={32} height={32} color={colors.elements.brand}/>),
            },
            onContinue: (amount, currency) => {
                if (amount === 0) {
                    Alert.alert(emojify('Hold on :dizzy:'), 'You must add an amount.', [
                        { text: 'Ok' },
                    ]);
                    return;
                }
                navigation.replace('GroupExpense', {
                    groupId,
                    offlineAmount: amount,
                    offlineCurrency: currency,
                });
            },
        }));
    }, [colors.elements.brand, groupId]);
    return (<>
      <SettingsItem icon={<IconRectangleListSolid gradientKey="orange"/>} title="Choose from your transactions" onPress={onFromTransactionScreen}/>
      <SettingsItem icon={<IconWifi off color={colors.status.offline}/>} title="Record offline transaction" onPress={onCustomTransaction}/>
    </>);
};
export const AddTransactionModal = {
    show: ({ groupId, navigation }) => {
        Modal.show(<AddTransactionModalContent groupId={groupId} navigation={navigation}/>, {
            containerStyle: groupModalContainerStyle,
            title: 'Add transaction',
        });
    },
    hide: Modal.hide,
};
